import { WORKSHOP_EVALUATION_DATA, UPDATE_WORKSHOP_EVALUATION_DATA } from "constants/api";
import axiosInstance from "helpers/axiosInstance";

// Types
export interface IWorkshopEvaluationDataEmployee {
  employeeId: string;
  employeeName: string;
  employeeNameAr: string;
  answers: IWorkshopEvaluationDataAnswer[];
}

export interface IWorkshopEvaluationDataAnswer {
  questionId: string;
  questionTitle: string;
  questionTitleAr: string;
  questionOrder: number;
  questionType: string; // "MCQ" or "OpenText"
  selectedAnswer?: string;
  selectedAnswerAr?: string;
  selectedOptionId?: string;
  answerText?: string;
  options: IWorkshopEvaluationDataOption[];
}

export interface IWorkshopEvaluationDataOption {
  id: string;
  description: string;
  descriptionAr: string;
  score: number;
  optionOrder: number;
}

export interface IUpdateWorkshopEvaluationDataRequest {
  workshopId: string;
  employeeAnswers: {
    employeeId: string;
    answers: {
      questionId: string;
      selectedOptionId?: string; // For MCQ
      answerText?: string; // For OpenText
    }[];
  }[];
}

// API Functions
export const getWorkshopEvaluationDataEmployees = async (
  workshopId: string
): Promise<IWorkshopEvaluationDataEmployee[]> => {
  const response = await axiosInstance.get(
    `${WORKSHOP_EVALUATION_DATA}/employees?workshopId=${workshopId}`
  );
  return response.data;
};

export const updateWorkshopEvaluationData = async (data: IUpdateWorkshopEvaluationDataRequest): Promise<void> => {
  // console.log('Calling updateWorkshopEvaluationData with URL:', UPDATE_WORKSHOP_EVALUATION_DATA);
  // console.log('Payload:', JSON.stringify(data, null, 2));
  await axiosInstance.post(UPDATE_WORKSHOP_EVALUATION_DATA, data);
};

